module.exports = __webpack_public_path__ + "static/img/protection-05.4ab364d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protection-05.png
// module id = 139
// module chunks = 0